import script from "./TopCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./TopCarousel.vue?vue&type=script&setup=true&lang=js"

import "./TopCarousel.vue?vue&type=style&index=0&id=16d2f469&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16d2f469"]])

export default __exports__